import { Component, OnInit, Inject, AfterContentChecked, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EntityTypes, FileUploadType } from 'src/app/core/enums';
import { Guid } from 'src/app/core/models/guid';
import { FileUploadService } from 'src/app/core/services/file-upload.service';
import { FileUpload2Service } from 'src/app/core/services/file-upload2.service';

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss']
})
export class UploadProgressComponent implements OnInit, AfterViewInit {

  customerID = 0;
  event: any; // hold the upload change event
  btnEnabled = false;
  uploadType: FileUploadType = FileUploadType.Undefined;
  departmentID = 0;
  entityID = 0;
  entityType = EntityTypes.Customer;
  treatmentID = 0;
  filesProgress = [];
  isProfileImage =false;



  private subscribeUploadComplete: any;
  private subscribeUploadProgress: any;

  constructor(
    public dialogRef: MatDialogRef<UploadProgressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fileUpload2: FileUpload2Service,
    public translate: TranslateService

  ) {

    this.event = data.event;
    this.customerID = data.customerID;
    this.uploadType = data.uploadType;
    this.isProfileImage = data.isProfileImage;
    this.departmentID = +data.departmentID || 0; // + plus sign convert to number
    this.treatmentID = +data.treatmentID || 0;
  }



  ngOnInit(): void {

    this.filesProgress = [];
    const files = this.event.currentTarget && this.event.currentTarget.files || this.event.target.files;
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      file.uid = Guid.newGuid();
      file.departmentID = this.departmentID;

      this.filesProgress.push({ fileName: file.name, uid: file.uid, progress: 0, error: '' });
    }
  }

  ngAfterViewInit() {
    this.onFileChange();
  }

  onClose(event) {

    this.dialogRef.close();
  }

  onFileChange() {

    if (this.subscribeUploadComplete) {
      this.subscribeUploadComplete.unsubscribe();
    }
    if (this.subscribeUploadProgress) {
      this.subscribeUploadProgress.unsubscribe();
    }

    this.subscribeUploadProgress = this.fileUpload2.onProgress.subscribe(result => {

      const file = this.filesProgress.filter(x => x.uid === result.fileUID)[0];
      if (result.error) {
        file.error = result.error;
      } else if (file && result.progress) {        
        file.progress = result.progress;
      }
    });


    this.subscribeUploadComplete = this.fileUpload2.onComplete.subscribe(result => {

      // on error
      if (result.error) {

        if (result.fileUID) {
          //this.title = this.translate.instant('MSG.ERROR');
          const file = this.filesProgress.filter(x => x.uid === result.fileUID)[0];
          file.error = result.error;
        }
        else {
          for (let index = 0; index < this.filesProgress.length; index++) {
            const element = this.filesProgress[index];
            element.error = result.error;
          }
        }
        this.data.error = result.error;
      }
      else {

        // on success
        //this.title = this.translate.instant('MSG.FILE_UPLOADED_SUCCESSFULLY');
        if (result.fileUID) {
          const file = this.filesProgress.filter(x => x.uid === result.fileUID)[0];

          if (file) {
            if (result.progress) {
              file.progress = result.progress;
            }
          }
        }
      }

      // enable button after all files uploaded or with error
      if (this.filesProgress.filter(x => x.progress == 100 || x.error != '').length == this.filesProgress.length) {
        this.btnEnabled = true;
      }

    });

    this.subscribeUploadProgress = this.fileUpload2.onProgress.subscribe(result => {
      const file = this.filesProgress.filter(x => x.uid === result.fileUID)[0];

      if (file) {
        if (result.error) {
          file.error = result.error;
        } else {
          file.progress = result.progress;
        }
      }
      // enable button after all files processed uploaded or with error
      if (this.filesProgress.length == this.filesProgress.filter(x => x.progress == 100 || x.error).length) {
        this.btnEnabled = true;
      }

    });


    var uploadEvent = this.event;

    if (this.uploadType == FileUploadType.Image) {

      this.fileUpload2.initPreference().subscribe(result => {
        this.fileUpload2.startUploadImage(uploadEvent, this.customerID, this.isProfileImage);
      });

    }
    else {
      if (this.treatmentID > 0) {
        this.entityID = this.treatmentID;
        this.entityType = EntityTypes.Treatment
      }
      else {
        this.entityID = this.customerID;
        this.entityType = EntityTypes.Customer;
      }




      // upload document
      this.fileUpload2.startUploadDocument(uploadEvent, this.customerID, this.departmentID, this.entityID, this.entityType);


    }

  }


}
